import { translate } from '@portal/services/i18n';
import { DatePicker } from 'antd';
import { Moment, unitOfTime } from 'moment';
import React, { useState } from 'react';
import locale from 'antd/es/date-picker/locale/pt_BR';
import { RangePickerProps } from 'antd/lib/date-picker';

const { RangePicker } = DatePicker;

export type AdvancedRangePickerProps = RangePickerProps & {
  placeholder?: [string, string];
  onChange: (values: Array<Moment | null> | null) => void;
  value: [Moment, Moment] | null;
  disabled?: boolean;
  limitRange?: boolean;
  allowClear?: boolean;
  rangeLimitValue?: number;
  rangeLimitUnit?: unitOfTime.Diff;
};

const AdvancedRangePicker = ({
  placeholder,
  onChange,
  value,
  disabled,
  allowClear = false,
  ...props
}: AdvancedRangePickerProps) => {
  const [dates, setDates] = useState<Array<Moment | null> | null>([]);
  const [resetValue, setResetValue] = useState<[null, null]>();

  const disabledDate = (current: Moment) => {
    if (!dates || dates.length === 0) {
      return false;
    }

    const tooLate =
      dates[0] &&
      current.diff(dates[0], props.rangeLimitUnit) >
        (props.rangeLimitValue ?? 0);
    const tooEarly =
      dates[1] &&
      dates[1].diff(current, props.rangeLimitUnit) >
        (props.rangeLimitValue ?? 0);

    return (tooEarly || tooLate) ?? false;
  };

  const handleOpenChange = (open: boolean) => {
    if (open) {
      setResetValue([null, null]);
      setDates([]);
    } else {
      setResetValue(undefined);
    }
  };

  return (
    <div className="advanced-rangepicker">
      <label className="advanced-rangepicker__label">
        <RangePicker
          {...props}
          disabledDate={props.limitRange ? disabledDate : undefined}
          onCalendarChange={
            props.limitRange ? (val) => setDates(val) : undefined
          }
          onOpenChange={props.limitRange ? handleOpenChange : undefined}
          allowClear={allowClear}
          size="middle"
          format={translate('APPLICATION.DEFAULT_DATE_FORMAT.MOMENT')}
          onChange={onChange}
          value={resetValue || value}
          placeholder={
            placeholder ?? [
              translate('COMPONENTS.ADVANCED_RANGE_PICKER.START'),
              translate('COMPONENTS.ADVANCED_RANGE_PICKER.FINAL'),
            ]
          }
          className="advanced-rangepicker__ranger"
          disabled={disabled}
          locale={locale}
        />
      </label>
    </div>
  );
};

export default AdvancedRangePicker;
